var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '../../styled';
import button from '../../themes/buttons';
import LoadingSpinner from '../loadingSpinner';
import { LoadingSpinnerWrapper, ContentWrapper, Container } from './elements';
const StyledContainer = styled(Container) `
  line-height: 2.5rem;
  height: 2.5rem;
  padding: 0 calc(0.75rem - ${({ theme }) => theme.buttons.border.NORMAL});
  border-radius: 20px;

  &.is-focus {
    padding-left: calc(0.75rem - ${({ theme }) => theme.buttons.border.BOLD});
    padding-right: calc(0.75rem - ${({ theme }) => theme.buttons.border.BOLD});
  }
`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const circleButtonGenerator = (buttonKey) => (_a) => {
    var { children, Icon, isLoading, disabled, focus, iconPosition, className = '' } = _a, restProps = __rest(_a, ["children", "Icon", "isLoading", "disabled", "focus", "iconPosition", "className"]);
    return (React.createElement(StyledContainer, Object.assign({ className: `${className} ${focus ? 'is-focus' : ''}`, buttonKey: buttonKey, buttonTheme: "buttons", disabled: isLoading || disabled, isLoading: isLoading }, restProps),
        isLoading && (React.createElement(LoadingSpinnerWrapper, { buttonKey: buttonKey, buttonTheme: "buttons" },
            React.createElement(LoadingSpinner, null))),
        React.createElement(ContentWrapper, { isLoading: isLoading, buttonKey: buttonKey, buttonTheme: "buttons" },
            Icon && (React.createElement(Icon, { position: iconPosition, size: "SMALL", color: button.types[buttonKey].iconColor })),
            children && React.createElement("span", null, children))));
};
export const Default = circleButtonGenerator('default');
export const Primary = circleButtonGenerator('primary');
export const Destructive = circleButtonGenerator('destructive');
export const Safe = circleButtonGenerator('safe');
export const Outline = circleButtonGenerator('outline');
export const Yellow = circleButtonGenerator('yellow');
//# sourceMappingURL=CircleButton.js.map